import { Action, createAction, handleActions } from "redux-actions";
import {
  GetLogSolicitudResponse,
  GetSolicitudEmisionResponse,
} from "~api/types";
import { Dispatch, GetState, Services } from "../types";

/**
 * `detalleSolicitudEmision` queda en null mientras carga: las cards se montan
 * recién cuando llega la respuesta.
 */
interface DetalleSolicitudHistoricaState {
  detalleSolicitudEmision: GetSolicitudEmisionResponse | null;
  isLoading: boolean;
  loadingError: boolean;
  logsUsuario: GetLogSolicitudResponse | null;
  isLoadingLog?: boolean;
  errorMessage?: string;
}

const getDetalleSolicitudEmisionInited = createAction(
  "OBTENER_DETALLE_SOLICITUDEMISION_INITED"
);
/**
 * Cuando no viene respuesta se guarda un objeto vacío en lugar de null: las
 * pantallas leen los sub-objetos del detalle sin guarda y romperían con null.
 */
const getDetalleSolicitudEmisionCompleted = createAction(
  "OBTENER_DETALLE_SOLICITUDEMISION_COMPLETED",
  (response: GetSolicitudEmisionResponse | null | undefined) => {
    let detalleSolicitudEmision =
      response ?? ({} as GetSolicitudEmisionResponse);

    return { detalleSolicitudEmision };
  }
);
const getDetalleSolicitudEmisionFailed = createAction(
  "OBTENER_DETALLE_SOLICITUDEMISION_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getDetalleSolicitudEmision = (id: string) => {
  return async (dispatch: Dispatch, getState: GetState, services: Services) => {
    try {
      dispatch(getDetalleSolicitudEmisionInited());

      const response = await services.api
        .solicitudesEmision()
        .getDetalleSolicitudEmision(id);

      dispatch(getDetalleSolicitudEmisionCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getDetalleSolicitudEmisionFailed(error));
    }
  };
};
const clearData = createAction("CLEAR_DATA_SH", () => ({}));

const getLogsUsuarioInited = createAction("OBTENER_LOGS_USUARIO_SH_INITED");

const getLogsUsuario = (id: string) => {
  return async (dispatch: Dispatch, getState: GetState, services: Services) => {
    try {
      dispatch(getLogsUsuarioInited());

      const response = await services.api
        .solicitudesEmision()
        .getLogsUsuario(id);

      dispatch(getLogsUsuarioCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getLogsUsuarioFailed(error));
    }
  };
};

const getLogsUsuarioCompleted = createAction(
  "OBTENER_LOGS_USUARIO_SH_COMPLETED",
  (response: GetLogSolicitudResponse | null | undefined) => {
    let logsUsuario = response ?? null;

    return { logsUsuario };
  }
);

const getLogsUsuarioFailed = createAction(
  "OBTENER_LOGS_USUARIO_SH_FAILED",
  (error: unknown) => ({
    error,
  })
);

const detalleSolicitudHistoricaReducerInitialState: DetalleSolicitudHistoricaState =
  {
    detalleSolicitudEmision: null,
    isLoading: true,
    loadingError: false,
    logsUsuario: null,
  };

const detalleSolicitudHistoricaReducer = handleActions<
  DetalleSolicitudHistoricaState,
  any
>(
  {
    [getDetalleSolicitudEmisionInited.toString()]:
      (): DetalleSolicitudHistoricaState => {
        return {
          ...detalleSolicitudHistoricaReducerInitialState,
        };
      },
    [getDetalleSolicitudEmisionCompleted.toString()]: (
      state: DetalleSolicitudHistoricaState,
      action: Action<{
        detalleSolicitudEmision: GetSolicitudEmisionResponse;
      }>
    ): DetalleSolicitudHistoricaState => {
      return {
        ...state,
        detalleSolicitudEmision: action.payload.detalleSolicitudEmision,
        isLoading: false,
      };
    },
    [getLogsUsuarioInited.toString()]: (
      state: DetalleSolicitudHistoricaState
    ): DetalleSolicitudHistoricaState => {
      return {
        ...state,
        logsUsuario: null,
        isLoadingLog: true,
      };
    },
    [getLogsUsuarioCompleted.toString()]: (
      state: DetalleSolicitudHistoricaState,
      action: Action<{ logsUsuario: GetLogSolicitudResponse | null }>
    ): DetalleSolicitudHistoricaState => {
      return {
        ...state,
        logsUsuario: action.payload.logsUsuario,
        isLoadingLog: false,
      };
    },
    [getLogsUsuarioFailed.toString()]: (
      state: DetalleSolicitudHistoricaState
    ): DetalleSolicitudHistoricaState => {
      return {
        ...state,
      };
    },
    [getDetalleSolicitudEmisionFailed.toString()]: (
      state: DetalleSolicitudHistoricaState,
      action: Action<{ error: any }>
    ): DetalleSolicitudHistoricaState => {
      return {
        ...state,
        loadingError: true,
        errorMessage: action.payload.error.responseStatus.message,
      };
    },
  },
  detalleSolicitudHistoricaReducerInitialState
);

export {
  detalleSolicitudHistoricaReducer,
  getDetalleSolicitudEmision,
  clearData,
  getLogsUsuario,
};
